export default __webpack_public_path__ + "static/media/food.24386a1e.svg";